import InfiniteScroll from 'react-infinite-scroller';
import { useChannelPosts } from '@/hooks/api/useChannelPosts';
import { ChangeEvent, useEffect, useState } from 'react';
import { ChannelPostTileElement } from '@/components/ChannelPostTileElement';
import { useLoading } from '@/providers/LoadingProvider';

type Props = {
  cid: string;
};
export const ChannelPostTile = ({ cid }: Props) => {
  const { setShowLoading } = useLoading();
  const [sort, setSort] = useState<string>('newest');
  const { infiniteQuery } = useChannelPosts(cid);
  const { data, isLoading, isFetching, fetchNextPage, refetch } = infiniteQuery(sort);

  useEffect(() => {
    setShowLoading(isLoading);
  }, [isLoading]);

  const onSortChanged = (e: ChangeEvent<HTMLInputElement>) => {
    setSort(e.target.value);
  };

  return (
    <section className="movies">
      <div className="segmented-control-wrapper">
        {['newest', 'popular', 'oldest'].map((val, idx) => (
          <input
            key={`sort_${idx}`}
            type="radio"
            id={`type${idx + 1}`}
            name="type"
            className="ctl"
            value={val}
            checked={val == sort}
            onChange={onSortChanged}
          />
        ))}
        <div className="segmented-control i3">
          <label htmlFor="type1" className="lbl">
            新しい順
          </label>
          <label htmlFor="type2" className="lbl">
            人気の動画
          </label>
          <label htmlFor="type3" className="lbl">
            古い順
          </label>
        </div>
      </div>

      {data && (
        <InfiniteScroll
          loadMore={() => {
            !isFetching && fetchNextPage();
          }}
          hasMore={data.pages[data.pages.length - 1].has_next}
          className={'items'}
        >
          {data.pages.map((resp) =>
            resp.channel_posts.map((channelPost) => (
              <ChannelPostTileElement key={`${channelPost.id}`} channel_post={channelPost} />
            ))
          )}
        </InfiniteScroll>
      )}
    </section>
  );
};
